import Helper from '@ember/component/helper';
import { formatNumber } from './format-number';
import pluralize from 'cio/utils/pluralize';
import joinWords from 'cio/utils/join-words';

function layoutUse(item) {
  let number = formatNumber([item.count]);
  let thing = pluralize(item.count, item.kind);
  return `${number} ${thing}`;
}

export function layoutUseCount([layout], { short = false } = {}) {
  let emailsCount = layout.get('emailsCount');

  if (emailsCount === 0) {
    return 'Not used in any campaigns or broadcasts';
  }

  let items = [
    { kind: 'campaign', count: layout.get('campaignsCount') },
    { kind: 'broadcast', count: layout.get('broadcastsCount') },
    { kind: 'transactional message', count: layout.get('transactionalMessagesCount') },
  ].filter((i) => i.count > 0);

  let itemString = joinWords(items.map(layoutUse));

  if (short) {
    return `Used in ${itemString}`;
  }

  let emailItem = { kind: 'email', count: emailsCount };
  let emailString = layoutUse(emailItem);

  return `Used in ${emailString} within ${itemString}`;
}

/*
  Basic Usage:

  ```handlebars
  {{layout-use-count layout}}
  ```

  ```handlebars
  {{layout-use-count layout short=true}}
  ```
*/
export default Helper.helper(layoutUseCount);
